import React, { useState, useEffect, useRef } from 'react';
import { SparklesIcon, GiftIcon, HeartIcon, TrendingUpIcon, CalendarIcon, QrCodeIcon, XIcon, CheckCircleIcon } from 'lucide-react';
import JsBarcode from 'jsbarcode';
import { motion, AnimatePresence } from 'framer-motion';
export function LoyaltyPointsSection() {
  const [currentPoints, setCurrentPoints] = useState(2450);
  const tierProgress = 65;
  const nextTierPoints = 3000;
  const [activeTab, setActiveTab] = useState('all');
  const barcodeRef = useRef<SVGSVGElement>(null);
  const memberId = '1234567890';
  const [selectedCoupon, setSelectedCoupon] = useState<{
    id: number;
    value: number;
    points: number;
  } | null>(null);
  const [purchaseStatus, setPurchaseStatus] = useState<'idle' | 'confirming' | 'success'>('idle');
  const [generatedCode, setGeneratedCode] = useState('');
  useEffect(() => {
    if (barcodeRef.current) {
      try {
        JsBarcode(barcodeRef.current, memberId, {
          format: 'CODE128',
          width: 2.5,
          height: 60,
          displayValue: false,
          background: '#ffffff',
          lineColor: '#000000',
          margin: 10
        });
      } catch (error) {
        console.error('Error generating barcode:', error);
      }
    }
  }, []);
  const coupons = [{
    id: 1,
    value: 10,
    points: 900,
    color: 'from-blue-500 to-blue-700'
  }, {
    id: 2,
    value: 15,
    points: 1200,
    color: 'from-blue-600 to-blue-800'
  }, {
    id: 3,
    value: 25,
    points: 1875,
    color: 'from-gray-400 to-gray-600'
  }, {
    id: 4,
    value: 60,
    points: 3900,
    color: 'from-gray-500 to-gray-700'
  }];
  const pointsHistory = [{
    id: 1,
    description: 'Purchase - Order #000013951',
    points: 26,
    date: '2024-01-15',
    type: 'earned'
  }, {
    id: 2,
    description: 'Purchase - Order #000013950',
    points: 25,
    date: '2024-01-10',
    type: 'earned'
  }, {
    id: 3,
    description: 'Birthday Bonus',
    points: 100,
    date: '2024-01-05',
    type: 'bonus'
  }, {
    id: 4,
    description: 'Redeemed - 10% Discount Voucher',
    points: -500,
    date: '2024-01-03',
    type: 'redeemed'
  }];
  const handleBuyClick = (coupon: {
    id: number;
    value: number;
    points: number;
  }) => {
    setSelectedCoupon(coupon);
    setPurchaseStatus('confirming');
  };
  const confirmPurchase = () => {
    if (selectedCoupon && currentPoints >= selectedCoupon.points) {
      setCurrentPoints(prev => prev - selectedCoupon.points);
      setGeneratedCode(`RABEH${Math.floor(Math.random() * 10000)}`);
      setPurchaseStatus('success');
    }
  };
  const closePurchaseModal = () => {
    setPurchaseStatus('idle');
    setSelectedCoupon(null);
    setGeneratedCode('');
  };
  return <div className="space-y-6" data-id="element-678" data-mp="5nzzerkca56o">
      {/* Points Balance Card */}
      <div className="bg-gradient-to-br from-[#1E2B55] to-[#3a4f94] rounded-2xl shadow-lg p-6 text-white relative overflow-hidden" data-id="element-679" data-mp="240ry3rbqonxk">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full pointer-events-none" data-id="element-680" data-mp="200zkh07hnrlc"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-tr-full pointer-events-none" data-id="element-681" data-mp="3hvqipphgo6zz"></div>
        
        <div className="flex items-start justify-between mb-6 relative z-10" data-id="element-682" data-mp="3rnwcn4r9wyht">
          <div data-id="element-683" data-mp="3rq0e7g1p9lex">
            <p className="text-sm text-blue-100 mb-1" data-id="element-684" data-mp="3vozrbnxl4ohg">Hello, Ahmed Gad</p>
            <p className="text-sm text-blue-200 mb-1" data-id="element-685" data-mp="3vrc4lnseeao6">Your balance</p>
            <p className="text-4xl font-bold" data-id="element-686" data-mp="2z0a73qyhjjsb">{currentPoints.toLocaleString()} <span className="text-lg font-normal" data-id="element-687" data-mp="33xjtsyuhphcg">points</span></p>
          </div>
          <div className="bg-white/10 p-2 rounded-xl backdrop-blur-sm border border-white/20" data-id="element-688" data-mp="37zn95yka5630">
            <QrCodeIcon className="w-12 h-12 text-white" data-id="element-689" data-mp="3cyqdthwclaag" />
          </div>
        </div>

        {/* Barcode Section */}
        <div className="bg-white rounded-xl p-4 relative z-10 text-center" data-id="element-690" data-mp="n9xw9r34zucy">
          <div className="flex items-center justify-center mb-2" data-id="element-691" data-mp="s8iwvrmawg1x">
            <svg ref={barcodeRef} className="max-w-full h-auto" data-id="element-692" data-mp="s6o9m6nk4buo"></svg>
          </div>
          <p className="text-sm text-gray-700 font-mono tracking-wider" data-id="element-693" data-mp="qs53ovqcd2wc">
            Member ID: {memberId}
          </p>
        </div>
      </div>

      {/* Buy Coupons */}
      <div data-id="element-694" data-mp="zsjsw66ff254">
        <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-695" data-mp="zt383f4ozcfg">Buy Coupons</h3>
        
        {/* Tabs */}
        <div className="flex gap-2 mb-4 overflow-x-auto hide-scrollbar pb-1" data-id="element-696" data-mp="vpne6qk0bq6g">
          <button onClick={() => setActiveTab('all')} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold whitespace-nowrap transition-colors ${activeTab === 'all' ? 'border-2 border-[#1E2B55] text-[#1E2B55]' : 'bg-gray-100 text-gray-600'}`} data-id="element-697" data-mp="19pg1sd08lqa7">
            <GiftIcon className="w-4 h-4" data-id="element-698" data-mp="1egocdcdazhoy" /> All coupons
          </button>
          <button onClick={() => setActiveTab('rabeh')} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold whitespace-nowrap transition-colors ${activeTab === 'rabeh' ? 'border-2 border-[#1E2B55] text-[#1E2B55]' : 'bg-gray-100 text-gray-600'}`} data-id="element-699" data-mp="1sgfwluuexube">
            <GiftIcon className="w-4 h-4" data-id="element-700" data-mp="2c295anbla584" /> Rabeh Gifts
          </button>
          <button onClick={() => setActiveTab('donations')} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold whitespace-nowrap transition-colors ${activeTab === 'donations' ? 'border-2 border-[#1E2B55] text-[#1E2B55]' : 'bg-gray-100 text-gray-600'}`} data-id="element-701" data-mp="2c051s6hlr88d">
            <HeartIcon className="w-4 h-4" data-id="element-702" data-mp="1t3n3154c682m" /> Donations
          </button>
        </div>

        <div className="grid grid-cols-2 gap-3" data-id="element-703" data-mp="1t5gbmpyif2d9">
          {coupons.map(coupon => <div key={coupon.id} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col" data-id="element-704" data-mp="1ecnxk2ysrzn9">
              <div className={`bg-gradient-to-br ${coupon.color} p-6 flex flex-col items-center justify-center text-white relative h-32`} data-id="element-705" data-mp="15eaqpwdppjw3">
                <div className="absolute inset-0 opacity-20 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZD0iTTAgMGgyMHYyMEgwem0xMCAxMGgxMHYxMEgxMHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjEiLz48L3N2Zz4=')]" data-id="element-706" data-mp="1abuafbt6iovf"></div>
                <div className="absolute top-2 left-2 bg-white/90 px-1.5 py-0.5 rounded text-[8px] font-bold text-[#1E2B55] flex items-center gap-1" data-id="element-707" data-mp="32db6w8rcbl3u">
                  <GiftIcon className="w-2.5 h-2.5" data-id="element-708" data-mp="3v16wyumemern" /> Rabeh
                </div>
                <span className="text-5xl font-light relative z-10 tracking-tighter" data-id="element-709" data-mp="3uz2umh45lnth">
                  <span className="text-lg font-bold mr-1" data-id="element-710" data-mp="3q2vn4jw4049f">SAR</span>{coupon.value}
                </span>
              </div>
              <div className="p-3 text-center bg-white flex flex-col items-center justify-center flex-grow" data-id="element-711" data-mp="3h1ecvi5duwsn">
                <p className="text-sm font-bold text-gray-900 mb-2" data-id="element-712" data-mp="2al2bl879kysu">{coupon.points} Points</p>
                <button onClick={() => handleBuyClick(coupon)} disabled={currentPoints < coupon.points} className={`w-full py-2 rounded-lg text-xs font-bold transition-colors ${currentPoints >= coupon.points ? 'bg-[#1E2B55] text-white hover:bg-[#162041]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-713" data-mp="25m8wxcg8r1r3">
                  {currentPoints >= coupon.points ? 'Buy Coupon' : 'Earn points to buy'}
                </button>
              </div>
            </div>)}
        </div>
      </div>

      {/* Points History */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-714" data-mp="18tsnhsjrqk5f">
        <div className="p-5 border-b border-gray-200" data-id="element-715" data-mp="18vvplay743qi">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-716" data-mp="1dtx7hsjvxx0e">Points History</h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-717" data-mp="1huqvsn18pdtt">
          {pointsHistory.map(item => <div key={item.id} className="p-5 hover:bg-gray-50 transition-colors" data-id="element-718" data-mp="3fkqpsnl9csc3">
              <div className="flex items-center justify-between" data-id="element-719" data-mp="3jmlr3s36v5pv">
                <div className="flex items-center gap-3" data-id="element-720" data-mp="30p22v4tx81ya">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${item.type === 'redeemed' ? 'bg-red-100' : 'bg-green-100'}`} data-id="element-721" data-mp="30nh7xe3p2gzw">
                    {item.type === 'bonus' ? <GiftIcon className="w-5 h-5 text-purple-600" data-id="element-722" data-mp="35fs9smhzwcv3" /> : item.type === 'redeemed' ? <SparklesIcon className="w-5 h-5 text-red-600" data-id="element-723" data-mp="2hrr7hvbetso4" /> : <TrendingUpIcon className="w-5 h-5 text-green-600" data-id="element-724" data-mp="2csoa8x1o8qqp" />}
                  </div>
                  <div data-id="element-725" data-mp="2qsz1i16w87ce">
                    <p className="font-medium text-gray-900" data-id="element-726" data-mp="2qp1h7c8kx9qx">
                      {item.description}
                    </p>
                    <p className="text-sm text-gray-600 flex items-center gap-1" data-id="element-727" data-mp="60nhtwaook56">
                      <CalendarIcon className="w-3 h-3" data-id="element-728" data-mp="123tjp8maw9n" />
                      {item.date}
                    </p>
                  </div>
                </div>
                <p className={`font-bold ${item.points > 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-729" data-mp="9hjcibmgtalb">
                  {item.points > 0 ? '+' : ''}
                  {item.points}
                </p>
              </div>
            </div>)}
        </div>
      </div>

      {/* Purchase Modal */}
      <AnimatePresence data-id="element-730" data-mp="s9lvvuqhr4z9">
        {purchaseStatus !== 'idle' && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closePurchaseModal} className="fixed inset-0 bg-black/50 z-[100]" data-id="element-731" data-mp="sbou321ss4f2" />
            <motion.div initial={{
          y: '100%'
        }} animate={{
          y: 0
        }} exit={{
          y: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-[101] p-6 pb-safe" data-id="element-732" data-mp="nhu2lcfyal5f">
              <div className="flex items-center justify-between mb-6" data-id="element-733" data-mp="2swwx600k9mws">
                <h3 className="text-xl font-bold text-gray-900" data-id="element-734" data-mp="2xvqbtvrl3jyj">
                  {purchaseStatus === 'confirming' ? 'Confirm Purchase' : 'Purchase Successful'}
                </h3>
                <button onClick={closePurchaseModal} className="p-2 text-gray-400 hover:text-gray-600" data-id="element-735" data-mp="2oujtdh5djz2n">
                  <XIcon className="w-6 h-6" data-id="element-736" data-mp="2a5dwhzu0ekxx" />
                </button>
              </div>

              {purchaseStatus === 'confirming' ? <div className="space-y-6" data-id="element-737" data-mp="2ey736t91g3cn">
                  <div className="bg-gray-50 rounded-xl p-4 text-center" data-id="element-738" data-mp="215heui61emcd">
                    <p className="text-gray-600 mb-2" data-id="element-739" data-mp="213ed50viv4rt">You are about to buy a</p>
                    <p className="text-3xl font-bold text-[#1E2B55] mb-2" data-id="element-740" data-mp="2572lvmvw46en">{selectedCoupon?.value} SAR Coupon</p>
                    <p className="text-sm font-medium text-gray-500" data-id="element-741" data-mp="1r94jlfuug0fi">for {selectedCoupon?.points} Points</p>
                  </div>
                  <div className="flex gap-3" data-id="element-742" data-mp="1ck2tkcgrq4kg">
                    <button onClick={closePurchaseModal} className="flex-1 py-3.5 rounded-xl font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-743" data-mp="1ckuqprq0kacu">
                      Cancel
                    </button>
                    <button onClick={confirmPurchase} className="flex-1 py-3.5 rounded-xl font-bold text-white bg-[#1E2B55] hover:bg-[#162041] transition-colors" data-id="element-744" data-mp="1himlcti1makq">
                      Confirm
                    </button>
                  </div>
                </div> : <div className="space-y-6 text-center" data-id="element-745" data-mp="20a6z4pdioee3">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-746" data-mp="20af9oam637m4">
                    <CheckCircleIcon className="w-10 h-10 text-green-600" data-id="element-747" data-mp="2e7lppxfias7n" />
                  </div>
                  <div data-id="element-748" data-mp="2a60ba7nbq5vc">
                    <p className="text-gray-600 mb-2" data-id="element-749" data-mp="2hbjk7xyb44sd">Your new coupon code is ready!</p>
                    <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 flex items-center justify-center gap-3" data-id="element-750" data-mp="2madzipx2fb7q">
                      <span className="text-2xl font-mono font-bold tracking-widest text-[#1E2B55]" data-id="element-751" data-mp="2r97dskk6f68y">{generatedCode}</span>
                    </div>
                    <p className="text-xs text-gray-400 mt-3" data-id="element-752" data-mp="2w1ih7xe4la69">This code has been saved to your coupons list.</p>
                  </div>
                  <button onClick={closePurchaseModal} className="w-full py-3.5 rounded-xl font-bold text-white bg-[#1E2B55] hover:bg-[#162041] transition-colors" data-id="element-753" data-mp="350lziz5gxljp">
                    Done
                  </button>
                </div>}
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}